// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__eQOd-","paragraph":"style_paragraph__3ttld","longDash":"style_longDash__1Z6iU"};